// React/TypeScript component using actual PersonAddAlt1Icon paths
import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const PersonTickIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props}>
    <path d="M13 8c0-2.21-1.79-4-4-4S5 5.79 5 8s1.79 4 4 4 4-1.79 4-4M1 18v2h16v-2c0-2.66-5.33-4-8-4s-8 1.34-8 4" />
    <path d="M23 7l-1.41-1.41L18 9.17l-1.59-1.58L15 9l3 3z" />
  </SvgIcon>
);

export default PersonTickIcon;
